import { DOWNLOAD, DOWNLOAD_SAP } from '../events';

export const userApiEvents: Record<string, string> = {
  [DOWNLOAD]: 'DOWNLOAD',
  [DOWNLOAD_SAP]: 'DOWNLOAD_SAP',
};
